module.exports = __webpack_public_path__ + "static/media/wall16.47082893.jpeg";